import React, { useEffect, useRef, useState } from 'react';
import { MakeReservationStyled } from './make-reservation.styled';
import FullCalendar from '../calendar/calendar';
import ReactCalendar from 'react-calendar';
import RadioButton from '../../base/radio-button/radio-button';
import Form from '../form/form';
import DetailEventForm from './components/detail-event-form/detail-event-form';
import { ValidationDetailEventFormSchema } from './components/detail-event-form/constants';
import { SvgImage, SvgType } from '../../base/svg/svg';
import i18n from '../../../translations/strings';
import { useDispatch, useSelector } from 'react-redux';
import {
  addCustomerEventAction,
  addSelectedDateCalendarEventAction,
  deleteCustomerEventAction,
  deleteSelectedDateCalendarAction,
  EventType,
  getAllEventsAction,
  getCustomerEventsAction,
  getEventsRefactor,
  getMonthKey,
  getRoomsAndServicesAction,
  getSpecificRoomAndMonthBookedIntervalsAction,
  getSpecificRoomAndMonthCustomerDataAction,
  makeReservationResetState,
  sendBookingAction,
  updateCustomerEventAction,
} from '../../../store/shared/make-reservation.store';
import moment from 'moment';
import { getRoom, getRoomLayouts, getStringDateName, } from '../../../utils/utils';
import {
  defaultValuesDetailForm,
  DetailEventWindowVariant,
  getDateRange,
  getEventBgColor,
  getEventCreateAndUpdateErrors,
  MakeReservationVariant,
} from './make-reservation.constants';
import ReservationSummary from './components/reservation-summary/reservation-summary';
import { ACCESS_TOKEN_KEY, getStringFromStorageGenerator, } from '../../../utils/local-storage';
import { useNavigate } from 'react-router-dom';
import { setTemporaryBookingDataFromLandingAction } from '../../../store/auth/registration.store';
import { Colors } from '../../../colors';
import { useModal } from '../modal-provider/hooks/modal-provider.hook';
import { ModalVariant } from '../modal-provider/components/modal/modal.constants';
import LinearLoading from '../../base/loading/linear-loading/linear-loading';
import { Grid, useMediaQuery } from '@mui/material';
import { mediaQueryMobileLimit } from '../../../utils/constants';
import 'react-calendar/dist/Calendar.css';
import './components/small-calendar.css';
import FooterBooking from './components/footer-booking/footer-booking';
import { FooterBookingVariant } from './components/footer-booking/constants';

export interface MakeReservationProps {
  variant?: MakeReservationVariant;
  customerData?: any;
  roomSelected?: string;
  closeCalendar?: () => void
}

const MakeReservation = (props: MakeReservationProps) => {
  const { variant = MakeReservationVariant.Customer } = props;
  // const { user } = useSelector((state: any) => {
  //   return state.user;
  // });

  const navigate = useNavigate();
  const { openModal } = useModal();
  const calendarRef = useRef();
  const [showReservationSummaryModal, setShowReservationSummaryModal] =
    useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedRoom, setSelectedRoom]: any = useState(null);
  const [typeDetailEventWindow, setTypeDetailEventWindow] = useState(
    DetailEventWindowVariant.Add,
  );
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [selectedLayout, setSelectedLayout] = useState<any>(null);
  const [resetForm, setResetForm] = useState(false);
  const [currentDateRange, setCurrentDateRange] = useState<any>(null);
  const [selectedDateEvent, setSelectedDateEvent] = useState<any>(null);

  const desktopMode = useMediaQuery(`(min-width:${mediaQueryMobileLimit}px)`);

  const dispatch = useDispatch();

  const {
    roomsAndServices,
    events,
    customerEvents,
    bookingSent,
    loading,
    error,
    smartObjects,
  } = useSelector((state: any) => {
    return state.makeReservation;
  });

  const { reservation } = useSelector((state: any) => {
    return state.handleReservation;
  });

  useEffect(() => {
    dispatch(getRoomsAndServicesAction());
  }, [dispatch]);

  useEffect(() => {
    if (roomsAndServices) {
      if (
        variant === MakeReservationVariant.AdminHandleReservation ||
        variant === MakeReservationVariant.AdminAllEvents
      ) {
        setSelectedRoom(roomsAndServices[0].id);
      }
      if (props.roomSelected) {
        setSelectedRoom(props.roomSelected);
      }
      const datesRange = getDateRange();
      setCurrentDateRange(datesRange);
    }
  }, [roomsAndServices, dispatch, props.roomSelected]);

  useEffect(() => {
    if (selectedRoom) {
      const start = moment(currentDateRange.start).format(
        'YYYY-MM-DD 00:00:00',
      );
      const end = moment(currentDateRange.end).format('YYYY-MM-DD 00:00:00');

      if (variant === MakeReservationVariant.Customer) {
        dispatch(
          getSpecificRoomAndMonthCustomerDataAction({
            room: selectedRoom,
            start: start,
            end: end,
            monthKey: getMonthKey(currentDateRange),
            // user: user
          }),
        );
      }

      if (variant === MakeReservationVariant.AdminHandleReservation) {
        dispatch(
          getCustomerEventsAction({
            room: selectedRoom,
            start: start,
            end: end,
            monthKey: getMonthKey(currentDateRange),
          }),
        );
        dispatch(
          getSpecificRoomAndMonthBookedIntervalsAction({
            room: selectedRoom,
            start: start,
            end: end,
            monthKey: getMonthKey(currentDateRange),
            reservation_id: reservation ? reservation.id : null,
            // user: user
          }),
        );
      }

      if (variant === MakeReservationVariant.AdminAllEvents) {
        dispatch(
          getAllEventsAction({
            room: selectedRoom,
            start: start,
            end: end,
            monthKey: getMonthKey(currentDateRange),
          }),
        );
      }
    }
  }, [selectedRoom, currentDateRange, dispatch]);

  useEffect(() => {
    if (bookingSent) {
      if (variant === MakeReservationVariant.AdminHandleReservation) {
        dispatch(makeReservationResetState());
        navigate(`/admin/handle-reservation-admin/${reservation.id}`);
      } else {
        openModal({
          title: i18n.t('booking.successModalTitle'),
          message: i18n.t('booking.reservationSent'),
          secondMessage: i18n.t('booking.reservationAdditionalMessage'),
          variant: ModalVariant.Success,
        });
        dispatch(makeReservationResetState());
        dispatch(getRoomsAndServicesAction());
      }
      setSelectedDate('');
    }
  }, [bookingSent, dispatch]);

  useEffect(() => {
    if (error) {
      openModal({
        message: error,
        variant: ModalVariant.Error,
      });
      dispatch(makeReservationResetState());
    }
  }, [error]);

  useEffect(() => {
    if (selectedDateEvent) {
      dispatch(addSelectedDateCalendarEventAction(selectedDateEvent))
    }
  }, [selectedDateEvent]);

  const openDetailWindow = (info: any) => {
    const startMoment = moment(info.date, 'YYYY-MM-DD HH:mm');
    if (
      startMoment.isBefore(moment().subtract(1, 'days')) ||
      variant === MakeReservationVariant.AdminAllEvents
    ) {
      return;
    }
    setResetForm(true);
    setSelectedEvent(null)
    setTypeDetailEventWindow(DetailEventWindowVariant.Add);
    setSelectedDate(info.dateStr);
    const newSelectedDateEvent = {
      id: new Date().getTime().toString() + 'selected',
      title: i18n.t('booking.selectedDateEvent'),
      start: `${info.dateStr} 00:01`,
      allDay: true,
      eventType: EventType.SelectedDateEvent,
      product: selectedRoom,
      month: getMonthKey(currentDateRange),
      selectedDate: info.dateStr
    };
    setSelectedDateEvent(newSelectedDateEvent)
  };

  const onAlertRemoveEvent = (event: any) => {
    openModal({
      message: variant === MakeReservationVariant.AdminHandleReservation ? i18n.t('handleReservation.deleteEventMessage') : i18n.t('booking.deleteEvent'),
      variant: ModalVariant.ConfirmationRequest,
      onConfirmClick: () => removeEvent(event)
    });
  };

  const removeEvent = (event: any) => {
    const eventToRemove = {
      ...event,
      month: getMonthKey(currentDateRange),
    };
    dispatch(deleteCustomerEventAction(eventToRemove));
    setResetForm(true);
    setSelectedEvent(null);
    setTypeDetailEventWindow(DetailEventWindowVariant.Add);
  };


  const onEventClick = (eventClicked: any) => {
    setSelectedDate(eventClicked.event.extendedProps.selectedDate);
    if (
      eventClicked.event.extendedProps.eventType === EventType.Unavailability
    ) {
      return;
    }
    if (
      eventClicked.event.extendedProps.eventType === EventType.SelectedDateEvent
    ) {
      setTypeDetailEventWindow(DetailEventWindowVariant.Add);
      setResetForm(true);
      setSelectedEvent(null);
      setSelectedLayout(null)
      return;
    }
    setTypeDetailEventWindow(DetailEventWindowVariant.UpdateDelete);
    const selectedEvent = events[selectedRoom][
      getMonthKey(currentDateRange)
    ].find((event: any) => {
      const sameId = event.id === eventClicked.event.id;
      const isUnavailabilityEvent =
        event.eventType === EventType.Unavailability;
      return sameId && !isUnavailabilityEvent;
    });
    setSelectedEvent(selectedEvent);
  };

  const addOrUpdateEvent = (data: any) => {
    const isUpdating =
      typeDetailEventWindow === DetailEventWindowVariant.UpdateDelete
    const start = `${isUpdating ? data.selected_event_date : selectedDate} ${data.start}`;
    const end = `${isUpdating ? data.selected_event_date : selectedDate} ${data.end}`;
    if (moment(start).isAfter(moment(end))) {
      openModal({
        message: i18n.t('booking.endBeforeStart'),
        variant: ModalVariant.Error,
      });
      return;
    }

    const createOrUpdateErrors = getEventCreateAndUpdateErrors(
      start,
      end,
      events,
      selectedRoom,
      currentDateRange,
      isUpdating,
      selectedEvent,
    );

    if (createOrUpdateErrors) {
      openModal({
        message: createOrUpdateErrors,
        variant: ModalVariant.Error,
      });
      return;
    }

    if (isUpdating) {
      setSelectedDate('');
      dispatch(
        updateCustomerEventAction({
          ...selectedEvent,
          title: data.title,
          description: data.description,
          visibleRange: {
            start: data.start,
            end: data.end,
          },
          attendees: data.attendees,
          services: data.services,
          selectedDate: data.selected_event_date,
          start: start,
          end: end,
          month: getMonthKey(currentDateRange),
          operator_management_choice: data.operator_management_choice
            ? data.operator_management_choice
            : null,
          remote_attendees: data.remote_attendees
            ? data.remote_attendees
            : null,
          layout: data.layout,
          payment_method: data.payment_method,
        }),
      );
      setResetForm(true);
      setTypeDetailEventWindow(DetailEventWindowVariant.Add);
      setSelectedEvent(null);
      dispatch(deleteSelectedDateCalendarAction(selectedDateEvent));
      setSelectedDateEvent(null)
      return;
    }

    const newEvent = {
      id: new Date().getTime().toString(),
      title:
        variant === MakeReservationVariant.Customer
          ? 'Evento richiesto'
          : 'Aggiunto da admin',
      start: start,
      end: end,
      allDay: false,
      description: data.description,
      visibleRange: {
        start: data.start,
        end: data.end,
      },
      attendees: data.attendees,
      services: data.services,
      selectedDate: selectedDate,
      product: selectedRoom,
      layout: data.layout,
      month: getMonthKey(currentDateRange),
      eventType: EventType.CustomerEvent,
      operator_management_choice: data.operator_management_choice
        ? data.operator_management_choice
        : null,
      remote_attendees: data.remote_attendees ? data.remote_attendees : null,
      payment_method: data.payment_method,
    };
    dispatch(addCustomerEventAction(newEvent));

    setResetForm(true);
    setSelectedDateEvent(null)
    dispatch(deleteSelectedDateCalendarAction(selectedDateEvent));
    setSelectedDate('')
  };

  const openReservationSummaryModal = () => {
    setShowReservationSummaryModal(true);
  };

  const sendBooking = (data: any) => {
    const token = getStringFromStorageGenerator(ACCESS_TOKEN_KEY);
    if (!token) {
      dispatch(setTemporaryBookingDataFromLandingAction(data));
      setShowReservationSummaryModal(false);
      navigate('/registration', { state: { isBookingFromLandingPage: true } });
      return;
    }

    let bookingData: any = {
      bookingId: reservation?.id,
      bookingNotes: reservation?.notes,
      data: data,
    };

    if (props.customerData) {
      bookingData.customerData = props.customerData;
    }
    dispatch(sendBookingAction(bookingData));
    setSelectedRoom(roomsAndServices[0].id);
    setShowReservationSummaryModal(false);
  };

  const onDiscardBooking = () => {
    dispatch(makeReservationResetState())
    dispatch(getRoomsAndServicesAction());
    props.closeCalendar && props.closeCalendar()
  }

  const onAlertDiscardBooking = () => {
    openModal({
      message: i18n.t('booking.discardAlertMessage'),
      variant: ModalVariant.ConfirmationRequest,
      onConfirmClick: () => onDiscardBooking()
    });
  }

  const renderEventContent = (eventInfo: any) => {
    return (
      <MakeReservationStyled.ContainerEventCalendar
        color={getEventBgColor(variant, eventInfo)}
        variant={variant}
      >
        <MakeReservationStyled.ContainerTitleEventCalendar>
          <MakeReservationStyled.TitleEventCalendar>
            {eventInfo.event.title}
          </MakeReservationStyled.TitleEventCalendar>
        </MakeReservationStyled.ContainerTitleEventCalendar>
        <MakeReservationStyled.TimeEventCalendar>
          {eventInfo.event.extendedProps.visibleRange && eventInfo.event.extendedProps.visibleRange.start +
            ' - ' +
            eventInfo.event.extendedProps.visibleRange.end}
        </MakeReservationStyled.TimeEventCalendar>
      </MakeReservationStyled.ContainerEventCalendar>
    );
  };

  const renderEventListSmallCalendar = () => {
    const removeEvent = (event: any) => {
      const eventToRemove = {
        ...event,
        month: getMonthKey(currentDateRange),
      };
      dispatch(deleteCustomerEventAction(eventToRemove));
    };

    return (
      customerEvents[selectedRoom]?.length > 0 &&
      customerEvents[selectedRoom].map((event: any, index: number) => (
        <MakeReservationStyled.SmallCalendarContainerEvent key={index}>
          <MakeReservationStyled.SmallCalendarEventDescription>
            {i18n.t('booking.eventDescriptionSmallCalendar', {
              day: getStringDateName(event.start),
              timeStart: moment.utc(event.start).format('HH:mm'),
              timeEnd: moment.utc(event.end).format('HH:mm'),
            })}
          </MakeReservationStyled.SmallCalendarEventDescription>
          <MakeReservationStyled.SmallCalendarContainerTrash
            onClick={() => removeEvent(event)}
          >
            <SvgImage type={SvgType.Trash} />
          </MakeReservationStyled.SmallCalendarContainerTrash>
        </MakeReservationStyled.SmallCalendarContainerEvent>
      ))
    );
  };

  const disableBookingButton = () => {
    if (getEventsRefactor(customerEvents).length === 0 && variant !== MakeReservationVariant.AdminHandleReservation ) {
      return true
    } else if (variant === MakeReservationVariant.AdminHandleReservation &&
      typeDetailEventWindow ===
      DetailEventWindowVariant.UpdateDelete) {
      return true
    }
    return false
  };


  const defaultValueRadioButton = () => {
    if (
      variant === MakeReservationVariant.AdminHandleReservation ||
      variant === MakeReservationVariant.AdminAllEvents
    ) {
      return roomsAndServices[0].id;
    } else if (
      variant === MakeReservationVariant.Customer &&
      props.roomSelected
    ) {
      return props.roomSelected;
    }
    return selectedRoom;
  };

  return (
    <MakeReservationStyled.Container>
      {roomsAndServices && (
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          <div>
            <MakeReservationStyled.Header container>
              <MakeReservationStyled.ContainerHeaderRooms item xs={12}>
                <Grid item xs={3} md={1} sx={{ alignItems: 'center' }}>
                  <MakeReservationStyled.HeaderTitle>
                    {i18n.t('booking.chooseRoom')}
                  </MakeReservationStyled.HeaderTitle>
                </Grid>
                <Grid item xs={9} md={11} sx={{ alignItems: 'center' }}>
                  <RadioButton
                    iconRight={{
                      icon: SvgType.Info,
                    }}
                    radios={roomsAndServices}
                    defaultValue={defaultValueRadioButton()}
                    onChange={room => {
                      setSelectedDate('');
                      setSelectedRoom(room);
                      setResetForm(true);
                      if (selectedDateEvent) {
                        dispatch(deleteSelectedDateCalendarAction(selectedDateEvent));
                      }
                      setSelectedDateEvent(null);
                    }}
                  />
                </Grid>
              </MakeReservationStyled.ContainerHeaderRooms>
            </MakeReservationStyled.Header>
            {selectedRoom && (
              <>
                <MakeReservationStyled.Body container>
                  {desktopMode ? (
                    <MakeReservationStyled.ContainerCalendar
                      item
                      display={{ xs: 'none', md: 'block' }}
                      md={9}
                    >
                      <MakeReservationStyled.LoadingContainer>
                        <LinearLoading loading={loading} />
                      </MakeReservationStyled.LoadingContainer>
                        <FullCalendar
                          selectable={
                            variant !== MakeReservationVariant.AdminAllEvents
                          }
                          reference={calendarRef}
                          renderEventContent={event =>
                            renderEventContent(event)
                          }
                          onDaySelect={info => openDetailWindow(info)}
                          onEventClick={event => onEventClick(event)}
                          events={
                            !loading &&
                            events[selectedRoom] &&
                            events[selectedRoom][getMonthKey(currentDateRange)]
                          }
                          onMonthChange={event => {
                            setResetForm(true);
                            setCurrentDateRange(event);
                          }}
                        />
                    </MakeReservationStyled.ContainerCalendar>
                  ) : (
                    <>
                      <MakeReservationStyled.SmallCalendarCustomerEventListContainer>
                        {renderEventListSmallCalendar()}
                      </MakeReservationStyled.SmallCalendarCustomerEventListContainer>
                      <MakeReservationStyled.ContainerSmallCalendar
                        item
                        display={{ md: 'none', xs: 'block' }}
                        xs={12}
                      >
                        <ReactCalendar
                          view={'month'}
                          defaultView={'month'}
                          prev2Label={null}
                          next2Label={null}
                          onChange={(date: any) => {
                            openDetailWindow({
                              dateStr: moment(date).format('YYYY-MM-DD'),
                              date: date,
                            });
                          }}
                          value={selectedDate}
                          tileContent={({ activeStartDate, date, view }) => {
                            const monthEvents =
                              events[selectedRoom] &&
                              events[selectedRoom][
                                getMonthKey(currentDateRange)
                              ];
                            const eventList: any = [];
                            if (monthEvents) {
                              monthEvents.map((item: any) => {
                                if (moment(item.start).isSame(date, 'day')) {
                                  eventList.push(item);
                                }
                              });
                            }
                            return (
                              eventList.length > 0 &&
                              eventList.map((event: any) => (
                                <MakeReservationStyled.SmallCalendarEventCard
                                  color={
                                    event.eventType === EventType.Unavailability
                                      ? Colors.Unavailability
                                      : Colors.Primary
                                  }
                                >
                                  &#x2022;
                                  {`${moment
                                    .utc(event.start)
                                    .format('HH:mm')}\n${moment
                                    .utc(event.end)
                                    .format('HH:mm')}`}
                                </MakeReservationStyled.SmallCalendarEventCard>
                              ))
                            );
                          }}
                          onActiveStartDateChange={activeStartDate => {
                            const datesRange = getDateRange(
                              activeStartDate.activeStartDate,
                            );
                            setCurrentDateRange(datesRange);
                            setResetForm(true);
                          }}
                        />
                      </MakeReservationStyled.ContainerSmallCalendar>
                    </>
                  )}

                  <MakeReservationStyled.ContainerDetailEvent
                    item
                    xs={12}
                    md={3}
                  >
                    <>
                      <MakeReservationStyled.TitleDetailEvent>
                        {i18n.t('booking.handleReservation')}
                      </MakeReservationStyled.TitleDetailEvent>
                      <MakeReservationStyled.SubtitleDetailEvent>
                        {!selectedDate
                          ? i18n.t('booking.noSelectedDate')
                          : i18n.t('booking.selectedDate')}
                      </MakeReservationStyled.SubtitleDetailEvent>
                    </>
                    {selectedDate && (
                      <Form
                        schema={ValidationDetailEventFormSchema(
                          getRoomLayouts(roomsAndServices, selectedRoom).find(
                            (layout: any) => layout.id === selectedLayout,
                          )?.capacity,
                        )}
                        defaultValues={defaultValuesDetailForm}
                      >
                        <DetailEventForm
                          room={getRoom(roomsAndServices, selectedRoom)}
                          onLayoutChange={(layout: string) =>
                            setSelectedLayout(layout)
                          }
                          smartObjects={smartObjects}
                          removeEvent={onAlertRemoveEvent}
                          selectedDate={selectedDate}
                          setResetForm={setResetForm}
                          resetForm={resetForm}
                          event={selectedEvent}
                          type={typeDetailEventWindow}
                          onSubmit={addOrUpdateEvent}
                          layouts={
                            selectedRoom
                              ? getRoomLayouts(roomsAndServices, selectedRoom)
                              : []
                          }
                          services={
                            selectedRoom
                              ? getRoom(roomsAndServices, selectedRoom).services
                              : []
                          }
                          variant={variant}
                        />
                      </Form>
                    )}
                  </MakeReservationStyled.ContainerDetailEvent>
                </MakeReservationStyled.Body>
                <ReservationSummary
                  sendBooking={(data: any) => sendBooking(data)}
                  isVisible={showReservationSummaryModal}
                  onClose={() => setShowReservationSummaryModal(false)}
                  reservations={getEventsRefactor(customerEvents)}
                  rooms={roomsAndServices}
                  variant={variant}
                  onDeleteEvent={event => removeEvent(event)}
                />
              </>
            )}
          </div>
          {variant !== MakeReservationVariant.AdminAllEvents && (
            <FooterBooking
              variant={FooterBookingVariant.FooterCalendar}
              calendarVariant={variant}
              footerCalendarProps={{
                showEvents:
                  variant !== MakeReservationVariant.AdminHandleReservation,
                events: getEventsRefactor(customerEvents),
                secondButton: {
                  onClickButton: () => onAlertDiscardBooking(),
                  buttonText: i18n.t('booking.discard'),
                },
              }}
              disabled={disableBookingButton()}
              buttonText={i18n.t(
                variant === MakeReservationVariant.Customer
                  ? 'booking.book'
                  : 'booking.saveChanges',
              )}
              onClickButton={openReservationSummaryModal}
            />
          )}
        </div>
      )}
    </MakeReservationStyled.Container>
  );
};

export default MakeReservation;
